import React, { useEffect, useState } from "react";
import AnnouncementForm from "./AnnouncementForm";
import AdminPageLayout from "../components/AdminPageLayout";
import "../components/AdminPageLayout.css";
import "./announcement.css";
import {
  fetchAllAnnouncements,
  deleteAnnouncement as deleteAnnouncementService,
  toggleAnnouncementStatus,
} from "./adminAnnouncementService";

const AdminAnnouncementPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { loadAnnouncements(); }, []);

  const loadAnnouncements = async () => {
    setLoading(true);
    const res = await fetchAllAnnouncements();
    if (res.status === 200) setAnnouncements(res.data);
    else alert(res.message || "Failed to load announcements");
    setLoading(false);
  };

  const deleteAnnouncement = async (id) => {
    if (!window.confirm("Delete this announcement?")) return;
    const res = await deleteAnnouncementService(id);
    if (res.status === 200 || res.status === 204) loadAnnouncements();
    else alert(res.message || "Delete failed");
  };

  const toggleEnable = async (id, currentEnabled) => {
    const res = await toggleAnnouncementStatus(id, !currentEnabled);
    if (res.status === 200) loadAnnouncements();
    else alert(res.message || "Update failed");
  };

  const onFormSaved = () => { setShowForm(false); loadAnnouncements(); };

  return (
    <AdminPageLayout
      title="Announcement Management"
      subtitle="Create and manage app announcements shown to users."
      instruction="Announcements appear as a banner inside the app. Use Priority to control display order (lower number = higher priority). Toggle the switch to enable or disable without deleting."
      actions={
        <button className="adm-btn adm-btn-primary" onClick={() => { setEditing(null); setShowForm(true); }}>
          + New Announcement
        </button>
      }
    >
      {showForm && (
        <div className="adm-form-card">
          <AnnouncementForm
            announcement={editing}
            onSaved={onFormSaved}
            onCancel={() => setShowForm(false)}
          />
        </div>
      )}

      {loading ? (
        <p className="adm-loading">Loading announcements…</p>
      ) : (
        <div className="adm-table-wrap">
          <table className="adm-table">
            <thead>
              <tr>
                <th>Priority</th>
                <th>Message</th>
                <th>Enabled</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {announcements.length === 0 ? (
                <tr><td colSpan="4" className="adm-empty">No announcements found</td></tr>
              ) : (
                announcements.map((a) => (
                  <tr key={a.id}>
                    <td><strong>{a.priority}</strong></td>
                    <td>{a.message}</td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" checked={a.enabled} onChange={() => toggleEnable(a.id, a.enabled)} />
                        <span className="slider"></span>
                      </label>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button className="adm-btn adm-btn-ghost adm-btn-sm" onClick={() => { setEditing(a); setShowForm(true); }}>Edit</button>
                        <button className="adm-btn adm-btn-danger adm-btn-sm" onClick={() => deleteAnnouncement(a.id)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </AdminPageLayout>
  );
};

export default AdminAnnouncementPage;
